import { DELETE_JUNCTURE } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_JUNCTURE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_JUNCTURE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_JUNCTURE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
